export enum PageTab {
  Users = "users",
  Permissions = "permissions",
}
